export const UPSELL_LOCALE_ROOT = "settings.paywalls.modal.tabs.upsell";
